import React, { useState } from 'react';

import { PageProperties } from '@sunwisesoftware/sunwise-template-core';
import { Box, UiDialog as Dialog } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DropdownCardMenu from 'common/components/DropdownCardMenu';

import styles from './Item.module.css';
import SortableItemContent from './SortableItemContent';

export const Position = { After: 1, Before: -1 };

const ItemContent = (props) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const {
        canModify,
        onDeletePage,
        onDuplicatePage,
        index,
        item,
        pageSize,
        selectedPageId,
        selectPage,
    } = props;

    const { blocked } = item;

    return (
        <Box
            sx={{ alignItems: 'center', display: 'flex', position: 'relative' }}
        >
            {canModify && (
                <>
                    {index != null ? (
                        <span className={styles.PageNumber}>{index}</span>
                    ) : null}
                </>
            )}

            <Box className={styles.draggableItemContent}>
                <SortableItemContent
                    handleClickSelect={selectPage}
                    index={index}
                    item={item}
                    pageSize={pageSize}
                    selectedPageId={selectedPageId}
                />
            </Box>

            {canModify && (
                <Box>
                    <DropdownCardMenu
                        items={[
                            {
                                handleClick: () => onDuplicatePage(item),
                                label: t('Duplicate'),
                                visible: !blocked,
                            },
                            {
                                handleClick: () =>
                                    onDeletePage(item.id, item.type === 'page'),
                                label: t('Delete'),
                            },
                            {
                                handleClick: () => {
                                    setOpen(true);
                                },
                                label: t('Settings'),
                                visible: selectedPageId === item.id && !blocked,
                            },
                        ]}
                        size="small"
                    />
                </Box>
            )}

            <Dialog
                onClose={() => setOpen(false)}
                open={open}
                size="sm"
                title={t('Page configuration')}
            >
                <PageProperties />
            </Dialog>
        </Box>
    );
};

ItemContent.propTypes = {
    canModify: PropTypes.bool,
    index: PropTypes.number,
    item: PropTypes.object,
    onDeletePage: PropTypes.func,
    onDuplicatePage: PropTypes.func,
    pageSize: PropTypes.string,
    selectedPageId: PropTypes.string,
    selectPage: PropTypes.func,
};

export default ItemContent;
